import React, { Component } from 'react';

var config = process.env;

class AdminBranchRolesComponent extends Component {

    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            rows: [],
        };
    }

    componentDidMount() {
        this.loadData();
    }

    loadData = () => {
        this.setState({ loading: true });
        fetch(`${config.REACT_APP_BASE_URL}${config.REACT_APP_VERSION}branch/admin/${this.props.email}`, {
            method: 'GET',
            headers: {
                'access-token': localStorage.getItem('token'),
                'Content-Type': 'application/json',
            }
        })
        .then(results => results.json())
        .then(data => {
            if (data.error > 0) {
                alert(data.message);
                return;
            }

            this.setState({
                loading: false,
                rows: data.data || [],
            });
        })
        .catch(() => {
            this.setState({ loading: false });
        });
    }

    handleRoleChange = (branchId, value) => {
        this.setState((prevState) => ({
            rows: prevState.rows.map((row) => (
                Number(row.id) === Number(branchId)
                    ? { ...row, role: value === '' ? null : Number(value), hasAccess: value !== '' }
                    : row
            )),
        }));
    }

    saveRole = (branchId, role) => {
        if (role == null || role === '') {
            fetch(`${config.REACT_APP_BASE_URL}${config.REACT_APP_VERSION}branch/admin/${this.props.email}/${branchId}`, {
                method: 'DELETE',
                headers: {
                    'access-token': localStorage.getItem('token'),
                    'Content-Type': 'application/json',
                }
            })
            .then(results => results.json())
            .then(data => {
                if (data.error > 0) {
                    alert(data.message);
                    return;
                }

                this.loadData();
            });
            return;
        }

        fetch(`${config.REACT_APP_BASE_URL}${config.REACT_APP_VERSION}branch/admin/${this.props.email}`, {
            method: 'POST',
            headers: {
                'access-token': localStorage.getItem('token'),
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                branchId: Number(branchId),
                role: Number(role),
            }),
        })
        .then(results => results.json())
        .then(data => {
            if (data.error > 0) {
                alert(data.message);
                return;
            }

            this.loadData();
        });
    }

    renderRows = () => {
        if (this.state.loading) {
            return (
                <tr>
                    <td colSpan="4" className="text-center">Cargando sucursales...</td>
                </tr>
            );
        }

        if (this.state.rows.length === 0) {
            return (
                <tr>
                    <td colSpan="4" className="text-center">No hay sucursales.</td>
                </tr>
            );
        }

        return this.state.rows.map((row) => (
            <tr key={row.id}>
                <td>{row.name}</td>
                <td>{row.isActive ? 'Activa' : 'Inactiva'}</td>
                <td>
                    <select
                        className="custom-select"
                        value={row.role == null ? '' : row.role}
                        onChange={(event) => this.handleRoleChange(row.id, event.target.value)}
                    >
                        <option value="">Sin acceso</option>
                        <option value="1">Administrador</option>
                        <option value="2">Encargado</option>
                        <option value="4">Finanzas</option>
                    </select>
                </td>
                <td className="text-right">
                    <button
                        type="button"
                        className="btn btn-sm btn-outline-primary"
                        onClick={() => this.saveRole(row.id, row.role)}
                    >
                        Guardar
                    </button>
                </td>
            </tr>
        ));
    }

    render() {
        return (
            <div>
                <p className="text-muted mb-3">
                    Configura el acceso de <b>{this.props.name}</b> por sucursal. Con una sucursal seleccionada, el listado muestra ese rol; en "Todos", muestra el rol más alto asignado.
                </p>
                <div className="table-responsive">
                    <table className="table mb-0">
                        <thead>
                            <tr>
                                <th>Sucursal</th>
                                <th>Estado</th>
                                <th>Rol</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            {this.renderRows()}
                        </tbody>
                    </table>
                </div>
            </div>
        );
    }
}

export default AdminBranchRolesComponent;
